
import store from '@/store'


export default function initDirective(Vue){
    
    Vue.directive("expend",function(el,bingind,vnode){
        let shrink = store.getters['app/shrink'];
        el.setAttribute('mode', shrink ? 'shrink' : 'expand');
    });
}